/* ============================================================
   FORMABOX — consent management
   Rules baked in on purpose:
   1. Nothing but strictly-necessary storage runs before a choice.
   2. Rejecting is exactly as easy as accepting (same weight, same
      number of clicks, same visual treatment).
   3. Every optional category is OFF by default — never pre-ticked.
   4. The choice is re-openable for ever from the footer.
   5. A rejection is stored too, so we don't nag on every page.

   SHOPIFY: when the storefront exposes the Customer Privacy API,
   the same choice is forwarded to it, so Shopify's own analytics
   and marketing pixels obey this banner instead of running anyway.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'fb.consent.v1';
  var CATEGORIES = ['analytics', 'personalisation', 'marketing'];

  var banner   = document.getElementById('consent-banner');
  var modal    = document.getElementById('consent-modal');
  if (!banner || !modal) return;

  var panel    = modal.querySelector('.modal__panel');
  var lastFocus = null;
  var release   = null;

  /* ---------- storage ---------------------------------------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)); }
    catch (e) { return null; }
  }
  function write(prefs) {
    var record = {
      version: 1,
      date: new Date().toISOString(),
      essential: true
    };
    CATEGORIES.forEach(function (c) { record[c] = !!prefs[c]; });
    try { localStorage.setItem(KEY, JSON.stringify(record)); } catch (e) { /* private mode */ }
    apply(record);
    return record;
  }

  /** Hand the decision to whatever needs it. Tag loading is gated here —
      one branch per category — and mirrored into Shopify when present. */
  function apply(record) {
    document.documentElement.dataset.consentAnalytics = String(!!record.analytics);

    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.setTrackingConsent === 'function') {
      try {
        api.setTrackingConsent({
          analytics:  !!record.analytics,
          marketing:  !!record.marketing,
          preferences: !!record.personalisation,
          sale_of_data: !!record.marketing
        }, function () { /* Shopify acknowledged the choice */ });
      } catch (e) { /* API not ready — the local record still stands */ }
    }

    window.dispatchEvent(new CustomEvent('fb:consent', { detail: record }));
  }

  /* ---------- banner ----------------------------------------- */
  function showBanner() { banner.hidden = false; }
  function hideBanner() { banner.hidden = true; }

  /* ---------- modal ------------------------------------------ */
  function openModal() {
    lastFocus = document.activeElement;
    var saved = read();
    CATEGORIES.forEach(function (c) {
      var input = modal.querySelector('#consent-' + c);
      if (input) input.checked = saved ? !!saved[c] : false;  // default OFF
    });
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    panel.querySelector('h2').setAttribute('tabindex', '-1');
    panel.querySelector('h2').focus();
    release = window.FB.trapFocus(panel, closeModal);
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (release) { release(); release = null; }
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- wiring ----------------------------------------- */
  function decide(value, label) {
    var prefs = {};
    CATEGORIES.forEach(function (c) { prefs[c] = value; });
    write(prefs);
    hideBanner(); closeModal();
    if (window.FB && window.FB.toast) window.FB.toast(label);
  }

  banner.querySelector('[data-consent="accept"]')
    .addEventListener('click', function () { decide(true, 'Cookies accepted. You can change this any time from the footer.'); });

  banner.querySelector('[data-consent="reject"]')
    .addEventListener('click', function () { decide(false, 'Cookies rejected. Only essential cookies stay on.'); });

  banner.querySelector('[data-consent="customise"]')
    .addEventListener('click', openModal);

  modal.querySelectorAll('[data-consent="close"]').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });
  modal.querySelector('.modal__backdrop').addEventListener('click', closeModal);

  modal.querySelector('[data-consent="save"]').addEventListener('click', function () {
    var prefs = {};
    CATEGORIES.forEach(function (c) {
      var input = modal.querySelector('#consent-' + c);
      prefs[c] = input ? input.checked : false;
    });
    write(prefs);
    hideBanner(); closeModal();
    window.FB.toast('Your preferences have been saved.');
  });

  modal.querySelector('[data-consent="reject-all"]')
    .addEventListener('click', function () { decide(false, 'Cookies rejected. Only essential cookies stay on.'); });

  // Footer entry point — always available, on every page.
  document.querySelectorAll('[data-consent="reopen"]').forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });

  /* ---------- boot ------------------------------------------- */
  var stored = read();
  if (stored) { apply(stored); } else { showBanner(); }

  // Shopify loads its privacy API asynchronously; re-apply once it lands.
  document.addEventListener('visitorConsentCollected', function () { /* no-op */ });
  window.addEventListener('load', function () {
    var again = read();
    if (again) apply(again);
  });
})();
